import { render, staticRenderFns } from "./service.vue?vue&type=template&id=59d9a30c&scoped=true"
import script from "./service.vue?vue&type=script&lang=js"
export * from "./service.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d9a30c",
  null
  
)

export default component.exports